module.exports = __webpack_public_path__ + "videos/houdini-deepfake-4.e736808.mp4";